import styled from 'styled-components';
import { Label } from 'modules/core/components';
import { COLORS } from 'modules/core/theme/colors';
import { Tooltip } from 'react-tooltip';

export const FormLabel = styled(Label)<{ $isAnimated?: boolean }>`
  position: relative;
  font-size: 14px;
  color: ${({ $isAnimated }) => ($isAnimated ? `transparent` : `black`)};
  transition: color 0.5s ease;
`;

export const GuidebookTooltip = styled(Tooltip)`
  z-index: 2000;
  padding: 6px 10px !important;
  max-width: 120%;
  border-radius: 6px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  background-color: ${COLORS.WHITE} !important;
  color: ${COLORS.BLACK} !important;
  font-size: inherit;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  position: absolute;
  left: 0 !important;

  .react-tooltip-arrow {
    left: 10px !important;
  }

  sup {
    font-size: 0.7em;
  }
`;

export const GuidebookLabelWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  max-width: var(--bs-col-11-width, 91.6667%);
  font-size: inherit;
  cursor: pointer;
`;

export const GuidebookLabelText = styled.span`
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;

  sup {
    font-size: 0.8em;
  }
`;

export const GuidebookInfoIcon = styled.img`
  flex: 0 0 auto;
  width: 0.9em;
  height: 0.9em;
  margin-left: 6px;
  font-size: inherit;
  align-self: center;
`;
